import { Controller } from "@hotwired/stimulus";

export default class FlashMessageController extends Controller {
  connect() {
    this.show();
    setTimeout(() => this.dismiss(), 5000);
  }

  show() {
    this.element.classList.add("transition", "ease-out", "duration-100");
    this.element.classList.add("transform", "opacity-0", "scale-95");
    this.element.classList.remove("hidden");

    requestAnimationFrame(() => {
      this.element.classList.remove("transform", "opacity-0", "scale-95");
      this.element.classList.add("transform", "opacity-100", "scale-100");

      Promise.all(this.element.getAnimations().map((a) => a.finished)).then(() => {
        this.element.classList.remove("transition", "ease-out", "duration-100");
        this.element.classList.remove("transform", "opacity-100", "scale-100");
      });
    });
  }

  dismiss() {
    this.element.classList.add("transition", "ease-in", "duration-75");
    this.element.classList.add("transform", "opacity-100", "scale-100");

    requestAnimationFrame(() => {
      this.element.classList.remove("transform", "opacity-100", "scale-100");
      this.element.classList.add("transform", "opacity-0", "scale-95");

      Promise.all(this.element.getAnimations().map((a) => a.finished)).then(() => {
        this.element.classList.remove("transition", "ease-in", "duration-75");
        this.element.classList.remove("transform", "opacity-0", "scale-95");
        this.element.classList.add("hidden");
      });
    });
  }
}
